/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Privacy_PolicyInputs */

const en_footer_privacy_policy = /** @type {(inputs: Footer_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

const lv_footer_privacy_policy = /** @type {(inputs: Footer_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privātuma politika`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Footer_Privacy_PolicyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const footer_privacy_policy = /** @type {((inputs?: Footer_Privacy_PolicyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Privacy_PolicyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_footer_privacy_policy(inputs)
	return en_footer_privacy_policy(inputs)
});